export default __webpack_public_path__ + "43f3e77dc82e79c85618d1583780eb36.svg";